import React, { useRef, useContext } from 'react'
import useCloseOnClickAway from '../../../shared/hooks/UseCloseOnClickAway'
import { WorkspaceContext } from '../WorkspaceContext'
import './roomsettingsinfopopup.scss'

const RoomSettingsInfoPopup = () => {
    const ctx = useContext(WorkspaceContext);
    if (!ctx) throw new Error("Workspace must be wrapped in WorkspaceContext.Provider");

    const popupRef = useRef<HTMLDivElement | null>(null);

    useCloseOnClickAway({
        targetRef: popupRef,
        onClose: () => ctx.setRoomSettingsInfoPopup(false),
    });

    return (
        <div ref={popupRef} id='room-settings-info-popup' className='fade-in'>
            <div className='rsip-top'>
                <h3>Room Settings</h3>

                <button className='ns-cancel' onClick={() => ctx.setRoomSettingsInfoPopup(false)}>
                    <svg className="x-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 111.01 111.01">
                        <g id="Layer_3" data-name="Layer 3">
                            <path
                                className="cls-1"
                                d="M232.21,289.66a10.1,10.1,0,0,1-14.31,0l-38.22-38.22-38.23,38.23a10.13,10.13,0,0,1-14.32-14.32l38.23-38.23L127.14,198.9a10.12,10.12,0,1,1,14.31-14.31l38.22,38.22,38.23-38.23a10.13,10.13,0,0,1,14.32,14.32L194,237.13l38.22,38.22A10.12,10.12,0,0,1,232.21,289.66Z"
                                transform="translate(-124.17 -181.62)"
                            />
                        </g>
                    </svg>
                </button>
            </div>

            <div className='rsip-line' />

            <div className='rsip-content'>
                <section>
                    <h4>Shareable Link</h4>
                    <p>Allows people to join from the room URL when enabled. If it is off, only existing members can use the room link.</p>
                </section>

                <section>
                    <h4>Track Members</h4>
                    <p>Controls whether member names and member-management tools are shown. It can be turned off later, but can only be turned back on before other members have joined.</p>
                </section>

                <section>
                    <h4>Max Members</h4>
                    <p>Limits the total number of joined members. Existing members can still rejoin after the room reaches the limit.</p>
                </section>

                <section>
                    <h4>Default Member Role</h4>
                    <p>Sets whether new joiners enter as read-only members or editors who can create and upload.</p>
                </section>
            </div>
        </div>
    )
}

export default RoomSettingsInfoPopup
